import { useState, useEffect } from "react"

const useReEntryChipEvent = (reEntryData) => {
    const [reEntryList, setReEntryList] = useState([])

    // 백엔드 데이터가 왔을 때, 해당 값으로 State 초기화
    useEffect(() => {
        if (reEntryData) setReEntryList([...reEntryData])
    }, [reEntryData])

    // ===== 리엔트리 칩 관련 이벤트 =====

    // 리엔트리 칩 변경 이벤트
    const changeReEntryChipEvent = (e, index) => {
        const tmp = [...reEntryList]
        tmp[index] = e.target.value

        setReEntryList(tmp)
    }

    // 리엔트리 칩 추가 이벤트
    const incReEntryChipEvent = () => {
        if (reEntryList.length < 5) {
            const tmp = [...reEntryList, null]
            setReEntryList(tmp)
        }
    }

    // 리엔트리 추가 칩 삭제 이벤트
    const deleteReEntryEvent = (index) => {
        const tmp = [...reEntryList]
        tmp.splice(index, 1)
        setReEntryList(tmp)
    }

    return [
        reEntryList,
        changeReEntryChipEvent, incReEntryChipEvent, deleteReEntryEvent
    ]
}

export default useReEntryChipEvent